import { render, staticRenderFns } from "./SurveyAccess.vue?vue&type=template&id=7f4a80f8"
import script from "./SurveyAccess.vue?vue&type=script&lang=js"
export * from "./SurveyAccess.vue?vue&type=script&lang=js"
import style0 from "./SurveyAccess.vue?vue&type=style&index=0&id=7f4a80f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports